
import React from "react";
import { useTheme } from "@material-ui/core";
import HvIconBase from "./IconBase";

const sizeSelector = (iconSize, height, width) => {
  if (height && width) {
    return { width, height };
  }

  switch (iconSize) {
    case "XS":
      return { width: 12, height: 12 };
    default:
    case "S":
      return { width: 16, height: 16 };
    case "M":
      return { width: 32, height: 32 };
    case "L":
      return { width: 96, height: 96 };
  }
};

const Preview = ({
  color,
  iconSize = "S",
  viewbox = "0 0 16 16",
  height,
  width,
  semantic,
  inverted = false,
  svgProps,
  ...others
}) => {
  const theme = useTheme();
  const getColor = c => theme.palette?.[c] || c;
  const colorArray = 
    (typeof color === "string" && [getColor(color)]) ||
    (Array.isArray(color) && color.map?.(getColor)) ||
    [theme.palette.acce1];

  if (semantic) {
    colorArray[0] = theme.palette?.[semantic] || colorArray[0];
  }

  if (inverted && colorArray[1]) {
    colorArray[1] = colorArray[0];
    colorArray[0] = "none";
  }

  const size = sizeSelector(iconSize, height, width);

  return (
    <HvIconBase name="Preview" iconSize={iconSize ?? "S"} {...others}>
      <svg xmlns="http://www.w3.org/2000/svg" viewBox={viewbox} height={size.height} width={size.width}   focusable={false} {...svgProps}>
  <path fill={colorArray[0]} className="color0"  d="M11 8a3 3 0 11-3-3 3.00007 3.00007 0 013 3zm5 0s-3.582 6-8 6-8-6-8-6 4-6 8-6 8 6 8 6zm-1.207.026a21.85215 21.85215 0 00-2-2.319C11.022 3.936 9.358 3 8 3s-3.008.928-4.77 2.684a21.6202 21.6202 0 00-2.019 2.343 18.07015 18.07015 0 001.852 2.279C4.249 11.535 6.079 13 8 13s3.73-1.45 4.91-2.667a17.98455 17.98455 0 001.883-2.307z" />
</svg>
    </HvIconBase>
)};

Preview.propTypes = HvIconBase.propTypes;

export default Preview;